import type { CSSProperties } from 'react';

export interface DividerWidgetProps {
  blockId?: string; // lets the editor find this rendered node in the DOM
  background?: string;
  color?: string;
  lineStyle?: CSSProperties['borderStyle'];
  thickness?: string | number;
  padding?: string;
  opacity?: number;
}

export default function DividerWidget({
  blockId,
  background,
  color = 'currentColor',
  lineStyle = 'solid',
  thickness = 1,
  padding = '0 56px',
  opacity,
}: DividerWidgetProps) {
  const borderWidth = typeof thickness === 'number' ? `${thickness}px` : thickness;
  return (
    <table role="presentation" width="100%" cellPadding={0} cellSpacing={0} border={0} style={{ background }}>
      <tbody>
        <tr>
          <td data-block-id={blockId} style={{ padding }}>
            <div style={{ borderTop: `${borderWidth} ${lineStyle} ${color}`, opacity, fontSize: 0, lineHeight: '0' }}>
              &nbsp;
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
}
